import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import { sanitize } from "dompurify";
import { UpdatesWrapper, Center, fadeIn } from "./styles";

const useStyles = makeStyles((theme) => ({
  root1: {
    width: "100%",
    backgroundColor: "white",
    boxShadow: "none",
  },
  root: {
    width: "100%",
    backgroundColor: "white",
    borderBottom: `0.2px solid #e4e5ef !important`,
    boxShadow: "none",
  },
  heading: {
    fontFamily: "openSans-bold, sans-serif",
    fontSize: "18px",
    color: "#293461",
    paddingLeft: "unset",
  },
  secondaryHeading: {
    width: "960px",
    fontFamily: "Poppins, sans-serif",
    fontSize: "14px",
    color: "#293461",
    lineHeight: "1.57",
  },
}));

const Index = ({ data = [], help = false }) => {
  const classes = useStyles();
  //const [states, setStates] = useState([]);
   const [expanded, setExpanded] = useState(null);


  useEffect(() => {
    if (data?.length) {
      const truearr = new Array(data.length).fill(true);
     setExpanded(truearr);
    }
  }, [data]);

 const handleIconClick = (index) => (event) => {
    event.stopPropagation(); // prevent bubbling to AccordionSummary
    setExpanded(expanded === index ? null : index);
  };

  return (
    <Center className="mui-tabs">
      <UpdatesWrapper >
        <Bg>
          {Array.isArray(data) && data.length > 0 ? (
            data.map((card, index) => (
              <Accordion
                key={index}
                expanded={expanded === index}
                className={
                  data.length - 1 === index ? classes.root1 : classes.root
                }
              >
                <AccordionSummary
                  expandIcon={
                    <div onClick={handleIconClick(index)} style={{ cursor: "pointer" }}>
                      <ExpandMoreIcon />
                    </div>
                  }
                  onClick={(e) => e.stopPropagation()} // prevent toggle on header click
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >
                  <div className={classes.heading}>
                    {`Q.${index + 1} ${card.question}`}
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <div
                    className={`${classes.secondaryHeading} ql-editor`}
                    dangerouslySetInnerHTML={{
                      __html: sanitize(card.answer),
                    }}
                  ></div>
                </AccordionDetails>
              </Accordion>
            ))
          ) : (
            <EmptyState>No {help ? `Help` : `FAQ's`} Found for this event</EmptyState>
          )}
        </Bg>
      </UpdatesWrapper>
    </Center>
  );
};

export default Index;

const Bg = styled.div`
  background-color: white;
  padding: 12px 22px;
  border-radius: 10px;
  border: solid 0.5px #e4e5ef;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  animation: ${fadeIn} 1s ease-in-out;
`;

const EmptyState = styled.div`
  color: ${COLORS.PRIMARY_BLACK};
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 20px;
`;
